import React, { useEffect, useState } from 'react'

/**
 * Wraps @crello/react-lottie so lottie-web never loads during Gatsby SSR.
 * (lottie-web touches `window` at module init.)
 */
export function Lottie(props) {
	const [Comp, setComp] = useState(null)
	useEffect(() => {
		let active = true
		import('@crello/react-lottie').then(m => {
			if (active) setComp(() => m.Lottie)
		})
		return () => {
			active = false
		}
	}, [])

	if (!Comp) {
		const { className, style, width, height, id, 'aria-hidden': ariaHidden } = props
		return (
			<span
				className={className}
				id={id}
				aria-hidden={ariaHidden}
				style={{
					display: 'inline-block',
					verticalAlign: 'middle',
					width,
					height,
					...style,
				}}
			/>
		)
	}
	return <Comp {...props} />
}
